export enum TaxBasis {
  IgnoreTax = 1,
  DefaultRate = 2,
  ExtractedAmount = 3
}
